import { useMemo, useCallback } from 'react';
import { categoryService } from '../services/categoryService';

export function useCategories(cats, householdId) {
  const incomeList = cats.income || [];
  // Filter out ".empty" sentinel values (Firebase drops empty arrays, so we use this placeholder)
  const expenseMap = useMemo(() => {
    const raw = cats.expense || {};
    const cleaned = {};
    for (const [k, v] of Object.entries(raw)) {
      cleaned[k] = Array.isArray(v) ? v.filter(s => s && s !== '.empty') : [];
    }
    return cleaned;
  }, [cats.expense]);
  const allSubCats = useMemo(() => Object.values(expenseMap).flat(), [expenseMap]);

  const getGroup = useCallback((subCat) => {
    for (const [g, items] of Object.entries(expenseMap)) {
      if (Array.isArray(items) && items.includes(subCat)) return g;
    }
    return incomeList.includes(subCat) ? "Income" : "Other";
  }, [expenseMap, incomeList]);

  const addIncomeCategory = useCallback((name) => {
    if (!name.trim()) return;
    categoryService.addIncomeCategory(householdId, cats, name.trim());
  }, [householdId, cats]);

  const removeIncomeCategory = useCallback((index) => {
    categoryService.removeIncomeCategory(householdId, cats, index);
  }, [householdId, cats]);

  const addExpenseGroup = useCallback((name) => {
    if (!name.trim()) return;
    categoryService.addExpenseGroup(householdId, cats, name.trim());
  }, [householdId, cats]);

  const removeExpenseGroup = useCallback((name) => {
    categoryService.removeExpenseGroup(householdId, cats, name);
  }, [householdId, cats]);

  const addSubCategory = useCallback((group, name) => {
    if (!name.trim()) return;
    categoryService.addSubCategory(householdId, cats, group, name.trim());
  }, [householdId, cats]);

  const removeSubCategory = useCallback((group, index) => {
    categoryService.removeSubCategory(householdId, cats, group, index);
  }, [householdId, cats]);

  return {
    incomeList,
    expenseMap,
    allSubCats,
    getGroup,
    addIncomeCategory,
    removeIncomeCategory,
    addExpenseGroup,
    removeExpenseGroup,
    addSubCategory,
    removeSubCategory,
  };
}
